// ../base/src/detect/index.ts
function detectProvider({
  silent = false,
  interval = 10,
  timeout = 200,
  walletFlag,
  isSingleWalletFlag,
  injectFlag = "ethereum",
  defaultWalletFlag
}) {
  return new Promise((resolve, reject) => {
    async function handleEthereum() {
      let provider = await getProvider(injectFlag, interval, timeout);
      if (!provider) {
        return reject(`Unable to detect window.${injectFlag}.`);
      }
      let mustBeSpecifiedWallet = false;
      let isSpecifiedWallet = false;
      const providers = provider.providers;
      if (providers?.length) {
        if (typeof walletFlag !== "string" || !walletFlag) {
          if (defaultWalletFlag) {
            provider = providers.find((provider2) => judgeIsSpecifiedWallet(provider2, defaultWalletFlag, isSingleWalletFlag));
          } else {
            provider = providers[0];
          }
        } else {
          provider = providers.find((provider2) => judgeIsSpecifiedWallet(provider2, walletFlag, isSingleWalletFlag));
        }
      } else {
        mustBeSpecifiedWallet = typeof walletFlag === "string" && !!walletFlag;
        isSpecifiedWallet = mustBeSpecifiedWallet && judgeIsSpecifiedWallet(provider, walletFlag, isSingleWalletFlag);
      }
      if (provider && !mustBeSpecifiedWallet || isSpecifiedWallet) {
        resolve(provider);
      } else {
        const message = `Non-${walletFlag} Wallet detected.`;
        !silent && console.error("detect-provider:", message);
        reject(message);
      }
    }
    handleEthereum();
  });
}
function judgeIsSpecifiedWallet(provider, walletFlag, isSingleWalletFlag = false) {
  const walletFlagKeys = provider ? Object.keys(provider).filter((key) => key?.startsWith("is")) : [];
  return !!provider && (isSingleWalletFlag ? walletFlagKeys.length === 1 && walletFlagKeys[0] === walletFlag : walletFlagKeys.includes(walletFlag));
}
var getProvider = async (injectFlag, interval, timeout) => {
  return new Promise((resolve) => {
    const _resolve = (res) => {
      clearInterval(intervalId);
      clearTimeout(timeoutId);
      resolve(res);
    };
    const timeoutId = setTimeout(() => {
      _resolve(null);
    }, timeout);
    const intervalId = setInterval(() => {
      if (globalThis[injectFlag]) {
        _resolve(globalThis[injectFlag]);
      }
    }, interval);
  });
};
export {
  detectProvider as default
};
